export const updateSticksQuantitySearchParam = (currentSticksURL, quantity) => {
    const paramString = window.location.search ? window.location.search.slice(1) : "";
    const searchParams = new URLSearchParams(paramString);
    searchParams.set("quantity", quantity.toString());
    window.history.replaceState(null, "", `${currentSticksURL}?${searchParams.toString()}`);
};
//# sourceMappingURL=updateSticksQuantitySearchParam.js.map